import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { getFilingConductorAnalysisJobPath } from './filing-conductor-analysis-paths';
import { FilingConductorAnalysisMessageListResponse } from './types';

export function useFilingConductorAnalysisMessages(jobId: string | null) {
  const path = jobId
    ? getFilingConductorAnalysisJobPath(jobId, 'messages')
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<FilingConductorAnalysisMessageListResponse>(
      path,
      SWRFetcher({ method: 'GET' }),
      { revalidateOnFocus: false, revalidateIfStale: false }
    );

  return {
    messages: data?.messages ?? [],
    count: data?.count ?? 0,
    isLoading,
    error,
    mutate,
  };
}
